import React from "react";
import loaderImage from "../../../assets/images/animation_loader.gif";
import PropTypes from "prop-types";

const PageLoader = ({ isLoading }) => {
  return (
    <div
      className="animatedLoader h-100 "
      style={
        isLoading
          ? {
              display: "flex",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 999999,
            }
          : {
              display: "none",
              position: "static",
            }
      }
    >
      <img
        alt="loader"
        loading="lazy"
        src={loaderImage}
        className="loaderImg"
      />
    </div>
  );
};

PageLoader.propTypes = {
  isLoading: PropTypes.bool,
};

export default PageLoader;
